import React, { useContext } from 'react';
import './i18n';
import { useTranslation } from 'react-i18next';
import { ModalErrorContext } from 'context/ModalError';
import NotificationModal from 'components/Modal/NotificationModal';
import { LoadingContext } from 'context/Loading';
import { Spinner } from 'react-bootstrap';

function AppCommon() {
  const { t } = useTranslation();
  const { loading } = useContext( LoadingContext );
  const {
    description, title, showModal, closeErrorModal, modalType,
  } = useContext( ModalErrorContext );

  let modalTitle: string | undefined;
  let isSuccess: boolean | undefined;

  let isWarning = false;

  if ( modalType === 'success' ) {
    modalTitle = title || t( 'hasSuccess' );
    isSuccess = true;
  } else if ( modalType === 'warning' ) {
    modalTitle = title;
    isSuccess = false;
    isWarning = true;
  } else if ( modalType === 'error' ) {
    modalTitle = title || t( 'hasError' );
    isSuccess = false;
  } else {
    modalTitle = undefined;
    isSuccess = undefined;
  }
  return (
    <>
      {loading
      && (
        <div className="app-loading">
          <Spinner
            animation="border"
            variant="primary"
            style={{
              width: '3rem',
              height: '3rem',
            }}
          />
        </div>
      )}
      <NotificationModal
        onClose={closeErrorModal}
        description={description}
        title={modalTitle}
        show={showModal}
        success={isSuccess}
        warning={isWarning}
      />
    </>
  );
}

export default AppCommon;
